import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Fish, ExternalLink } from "lucide-react";
import { club, navItems } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={club.logo}
                alt={club.name}
                className="h-14 w-14 object-contain bg-white/95 rounded-full p-1"
              />
              <div className="leading-tight">
                <span className="block font-serif text-lg">Fischerei Verein</span>
                <span className="block font-serif text-lg -mt-1">Fürth e.V.</span>
              </div>
            </div>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Ein traditionsreicher Angelverein aus Fürth – gegründet 1881.
              Wir pflegen unsere Gewässer und die Gemeinschaft. Petri Heil!
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-600 text-sm uppercase tracking-wider mb-4 text-accent">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-primary-foreground/75 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-600 text-sm uppercase tracking-wider mb-4 text-accent">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-primary-foreground/75">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-accent" />
                <span>
                  {club.address.heim}
                  <br />
                  {club.address.city}
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-sm">
                <Mail className="h-4 w-4 mt-0.5 shrink-0 text-accent" />
                <a
                  href={`mailto:${club.emails.vorstand}`}
                  className="text-primary-foreground/75 hover:text-white transition-colors break-all"
                >
                  {club.emails.vorstand}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-sm">
                <Mail className="h-4 w-4 mt-0.5 shrink-0 text-accent" />
                <a
                  href={`mailto:${club.emails.anfrage}`}
                  className="text-primary-foreground/75 hover:text-white transition-colors break-all"
                >
                  {club.emails.anfrage}
                </a>
              </li>
            </ul>
          </div>

          {/* Online */}
          <div>
            <h4 className="font-600 text-sm uppercase tracking-wider mb-4 text-accent">
              Online
            </h4>
            <a
              href={club.hejfish}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm bg-accent text-accent-foreground font-600 px-4 py-2.5 rounded-md hover:bg-accent/90 transition-colors"
            >
              <Fish className="h-4 w-4" />
              Angelkarten kaufen
              <ExternalLink className="h-3.5 w-3.5" />
            </a>
            <a
              href={club.pruefung}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 flex items-center gap-2 text-sm text-primary-foreground/75 hover:text-white transition-colors"
            >
              Fischerprüfung <ExternalLink className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-foreground/60">
            © {new Date().getFullYear()} {club.name}. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4 text-xs text-primary-foreground/60">
            <Link to="/impressum" className="hover:text-white transition-colors">
              Impressum
            </Link>
            <span className="text-white/20">•</span>
            <Link to="/datenschutz" className="hover:text-white transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
